<template>
  <div id="app">
    <Navigation :title="navigationTitle" fixed isListenClick @listenClick="handleClickGoHome()" v-if="showNavigation"/>
    <div class="dsh-app-content" :class="{showNavigation: showNavigation}">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
    <AuthBar v-if="$route.meta.isTab && $route.name !== 'home' && $route.name !== 'search' && !$route.query.channel && (!token || (token && !authTbAccountName))" />
    <HomeTabs v-if="$route.meta.isTab && !$route.query.channel" />
  </div>
</template>
<script>
import AuthBar from '@/components/authBar'
import HomeTabs from '@/components/homeTabs'
import { mapGetters } from 'vuex'
import LoginService from '@/services/login'
import Navigation from '@/components/navigation'
export default {
  name: 'index',
  components: {
    AuthBar,
    HomeTabs,
    Navigation,
  },
  data() {
    return {
      navigationRouteNameArr: ['home', 'search', 'mine', 'pddHome', 'pddSearch', 'pddMine', 'jdHome', 'jdSearch', 'jdMine']
    }
  },
  created() {
    this.checkBindTb()
  },
  computed: {
    ...mapGetters([ 'token', 'authTbAccountName', 'navigationTitle', 'fromSourceUrl' ]),
    showNavigation() {
      return this.navigationTitle && this.navigationRouteNameArr.indexOf(this.$route.name) > -1
    }
  },
  watch: {
    token() {
      this.checkBindTb()
    },
  },
  methods: {
    /**
     * 检查是否绑定淘宝账户
     */
    checkBindTb() {
      if (this.token) {
        LoginService.checkBindTb((isBind, data) => {}, 0)
      }
    },
    /**
     * 点击返回主页
     */
    handleClickGoHome() {
      window.location.href = this.fromSourceUrl
    }
  }
}
</script>
<style lang="scss">
* {
  margin: 0;
  padding: 0;
  list-style: none;
  box-sizing: border-box;
}
html,
body {
  line-height: 1.5 !important;
  height: 100vh;
  width: 100vw;
  -webkit-overflow-scrolling: touch;
}
#app {
  font-family: -apple-system, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #232321;
  font-size: 28px;
  height: 100vh;
  width: 100vw;
}
.dsh-app-content {
  position: relative;
  height: 100vh;
  width: 100vw;
  &.showNavigation {
    padding-top: 0.88rem;
  }
}
.tabCateSwiper-scrollbar {
  // 首页分类菜单滚动条
  .swiper-scrollbar-drag {
    height: 0.06rem;
    border-radius: 0.06rem;
    background: -webkit-linear-gradient(left,#f42f19,#FE560A )!important;
  }
}
</style>
